import { render, staticRenderFns } from "./verification.vue?vue&type=template&id=278ae265&scoped=true"
import script from "./verification.vue?vue&type=script&lang=js"
export * from "./verification.vue?vue&type=script&lang=js"
import style0 from "./verification.vue?vue&type=style&index=0&id=278ae265&prod&lang=css"
import style1 from "./verification.vue?vue&type=style&index=1&id=278ae265&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278ae265",
  null
  
)

export default component.exports